import { Pet, PetProfileFormValues } from '@app/core/models';
import { WeightFormValue } from '@app/shared/components/weight-form/weight-form';
import { Tool } from '@app/shared/utils';
import { createAction, props } from '@ngrx/store';

/**
 * Patient Profile actions
 */

/**
 * Actions to set patient profile, weight, and "Is New" flag
 */
export const setPatientProfile = createAction('[Patient Profile] Set', props<{ profile: PetProfileFormValues }>());
export const setPatientWeight = createAction('[Patient Profile] Set Weight', props<{ weight: WeightFormValue; tool: Tool }>());
export const setIsNewPet = createAction('[Patient Profile] Set Is New Pet', props<{ isNewPet: boolean }>());
export const setOngoingPet = createAction('[Patient Profile] Set Ongoing Pet', props<{ ongoingPet: Pet | null }>());

/**
 * Actions to autosave new (draft) pet
 */
export const autoSaveNewPet = createAction('[Patient Profile] Autosave New Pet', props<{ tool: Tool }>());
export const autoSaveNewPetSuccess = createAction('[Patient Profile] Autosave New Pet Success', props<{ pet: Pet }>());
export const autoSaveNewPetError = createAction('[Patient Profile] Autosave New Pet Pet Error');

/**
 * Action to reset the state
 */
export const resetPatientProfileState = createAction('[Patient Profile] Reset');
